module.exports = __webpack_public_path__ + "media/images/screens/03_sousNav_v2-670c7b0458a8a7efe1ca2be52ca534e5.jpg";